import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch all available permission types
export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async () => {
    const response = await axios.get(
      `https://api.generalhome.sa/api/Authorization/GetPermissions`
    );
    console.log(response.data)
    return response.data?.dto || response.data;
  }
);

// Single async action for adding/updating permissions
export const updateUserPermission = createAsyncThunk(
  "permissions/updateUserPermission",
  async ({ Type, Value, UserId }, { rejectWithValue }) => {
    try {
      await axios.post(
        "https://api.generalhome.sa/api/Authorization/AddPermissions",
        {
          Type,
          Value: Value.toString(),
          UserId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Return simplified response data
      return {
        userId: UserId,
        permission: {
          Type,
          Value,
        },
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState: {
    availablePermissions: [], // All possible permission types
    loading: false,
    error: null,
    lastUpdated: null,
  },
  reducers: {
    resetPermissionsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchPermissions
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure we're storing an array of permissions
        state.availablePermissions = Array.isArray(action.payload)
          ? action.payload
          : [];
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Handle updateUserPermission
      .addCase(updateUserPermission.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserPermission.fulfilled, (state) => {
        state.loading = false;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(updateUserPermission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errors || action.error.message;
      });
  },
});

export const { resetPermissionsError } = permissionsSlice.actions;
export default permissionsSlice.reducer;
